import classNames from 'classnames';
import React, { ReactNode, useCallback, useState } from 'react';
import { UiButton } from 'src/components/UI/Button';
import { useRefClickOutside } from 'src/utils/hooks/useRefClickOutside';
import { ChildrenPropType } from 'src/utils/types';

type Props = {
  children: ChildrenPropType;

  simple?: boolean;
  raw?: boolean;
  iconTrigger?: boolean;
  itemClickClose?: boolean;
  prefixChildren?: ReactNode;
};

export const GridActions: React.FC<Props> = ({
  simple,
  children,
  raw = false,
  iconTrigger,
  itemClickClose,
  prefixChildren,
}: Props) => {
  const [show, setShow] = useState(false);

  const setShowMemo = useCallback(
    (v: boolean) => () => {
      setShow(v);
    },
    []
  );

  const ref = useRefClickOutside<HTMLDivElement>(show, setShowMemo(false));

  const innerComponents = (
    <>
      {prefixChildren}

      {iconTrigger ? (
        <i role="presentation" className="material-icons" onClick={setShowMemo(!show)}>
          more_vert
        </i>
      ) : (
        <UiButton tag="a" className="dropdown-toggle" onClick={setShowMemo(!show)}>
          <i className="material-icons">more_vert</i>
        </UiButton>
      )}

      {show && (
        <ul role="presentation" className="dropdown-menu" onClick={itemClickClose ? setShowMemo(false) : undefined}>
          {children}
        </ul>
      )}
    </>
  );

  return raw ? (
    <div className={classNames({ open: show })}>{innerComponents}</div>
  ) : (
    <div className={simple ? 'simple-actions' : 'btn-group'} ref={ref}>
      <div className={classNames({ open: show, 'buttons-container': !simple })}>{innerComponents}</div>
    </div>
  );
};
